module.exports = __webpack_public_path__ + "static/media/chart-pie-simple-circle-dollar.c369bb8a.svg";